export default __webpack_public_path__ + "static/media/logo.d5f7d37f.svg";